import { render } from "./PushNotificationMaster.vue?vue&type=template&id=2768eb0f&scoped=true"
import script from "./PushNotificationMaster.vue?vue&type=script&lang=js"
export * from "./PushNotificationMaster.vue?vue&type=script&lang=js"

import "./PushNotificationMaster.vue?vue&type=style&index=0&id=2768eb0f&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2768eb0f"]])

export default __exports__